export default {"src":"/_next/static/media/copy-link-white.884e6070.svg","height":21,"width":17};